export const mockMaterials = [
  {
    line: 1,
    availLocQty: 100,
    quantity: 2,
    partType: 'REEL',
    custLine: 1,
    mfrPartNumber: '520093702/00',
    mfgBrand: 'ANDREW',
    supplierPoNumber: '---',
    description: '7/8" WIRELESS COAX CONN...',
    customerPartNumber: '---',
    io: 'IO',
    dateCode: '16023- US - ...',
    shipType: 'Delivery By',
  },
  {
    line: 2,
    availLocQty: 17,
    quantity: 1,
    partType: 'STD',
    custLine: 2,
    mfrPartNumber: 'ACG24K',
    mfgBrand: 'PANDUIT',
    supplierPoNumber: '---',
    description: '6 AWG ARMORED CABLE GROUND KIT',
    customerPartNumber: '---',
    io: 'IO',
    dateCode: '16023- US - ...',
    shipType: 'Delivery By',
  },
  {
    partBomId: 4326285,
    line: 3,
    availLocQty: 17,
    quantity: 1,
    partType: 'BOM',
    custLine: 3,
    mfrPartNumber: 'UCM-01U-EXT',
    mfgBrand: 'Accu-Tech',
    supplierPoNumber: '---',
    description: 'Extended Universal Connector Mount Housing',
    customerPartNumber: '---',
    io: 'IO',
    dateCode: '16023- US - ...',
    shipType: 'Delivery By',
  },
];

export const mockOrderData = {
  orderNumber: '100029106',
  customerName: 'TEST CUSTOMER - DDP',
  orderId: '100029106',
  sourceSystem: 'Partfiniti',
  submittedDate: 'Draft',
  orderStatus: 'Order Status',
};

export const mockTabs = [
  'Summary',
  'List of Materials',
  'Ship Groups',
  'Charges',
  'Order Notes',
  'Timeline',
  'Additional Order Info',
  'Order Holds',
  'Cost Adjustments',
  'Associated Orders',
  'Order Document',
  'Related',
];

export const actionButtons = [
  { icon: '💾', text: 'Save' },
  { icon: '💾', text: 'Save & Close' },
  { icon: '➕', text: 'New Order' },
  { icon: '🗑', text: 'Delete' },
  { icon: '📄', text: 'Generate Document' },
  { icon: '🔄', text: 'Refresh' },
  { icon: '🔗', text: 'Open a new tab' },
  { icon: '📋', text: 'Copy Order' },
  { icon: '📤', text: 'Submit Order' },
  { icon: '💰', text: 'Calculate Tax' },
  { icon: '📝', text: 'Word Templates' },
];
